import { useEffect } from 'react';

import { usePedidoCompraContext } from 'context/PedidoCompraContext';

export function usePedidoBeforeUnload(): void {
    const { isSavingCarrinho } = usePedidoCompraContext();

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
            if (isSavingCarrinho) {
                event.preventDefault();
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isSavingCarrinho]);
}
